import ErrorSharpIcon from '@mui/icons-material/ErrorSharp';
import { Box, FormControl, TextField } from '@mui/material';
import { ChangeEvent, useState } from 'react';
import { ValidationError } from 'yup';
import useStore from '~/store';
import { Message } from '../types';
import { CpfMask } from './input-mask';
import { containerInput, containerMessage, inputStyle } from './styles';
import schema from './validation';

interface Props {
  content?: Message['content'];
  author?: Message['author'];
  Component?: Message['Component'];
  handleValidateInputs: (key: 'email' | 'name' | 'cpf', isValid: boolean) => void;
}

export const InputCpf = ({ handleValidateInputs }: Props) => {
  const { quote, setCpf } = useStore((store) => ({
    quote: store.quote,
    setCpf: store.SetCpf
  }));
  const { cpf } = quote;

  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState('');

  const validateCpfValue = async (value: string) => {
    try {
      await schema.validate({
        cpf: value
      });
      setHelperText('');
      setError(false);
      handleValidateInputs('cpf', true);
    } catch (err) {
      if (err instanceof ValidationError) {
        setError(true);
        handleValidateInputs('cpf', false);
        setHelperText(err.message);
      }
    }
  };

  const handleChangeCpf = (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const newCpfValue = event.target.value;

    setCpf(newCpfValue);
    validateCpfValue(newCpfValue);
  };

  return (
    <Box>
      <Box sx={() => containerMessage(error)}>
        <FormControl variant="outlined" sx={containerInput}>
          <TextField
            value={cpf}
            onChange={handleChangeCpf}
            error={error}
            helperText={helperText}
            type="text"
            variant="outlined"
            placeholder="Informe seu cpf"
            sx={inputStyle}
            InputProps={{
              endAdornment: error && <ErrorSharpIcon color="error" />,
              inputComponent: CpfMask as any
            }}
          />
        </FormControl>
      </Box>
    </Box>
  );
};
